import React from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "@/shared/components/common/logo";

interface BlinkingLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  text?: string;
}

const BlinkingLogo: React.FC<BlinkingLogoProps> = ({ 
  className = "", 
  size = "xl",
  text
}) => {
  const { t } = useTranslation("common");
  const label = text ?? t("loading.default");
  const sizeClasses = {
    sm: "w-12 h-12",
    md: "w-16 h-16", 
    lg: "w-24 h-24",
    xl: "w-32 h-32"
  };

  const textSizeClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base", 
    xl: "text-lg"
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <Logo 
        className={`${sizeClasses[size]} object-contain animate-pulse`}
      />
      {label && (
        <span className={`text-muted-foreground ${textSizeClasses[size]}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default BlinkingLogo;
